// Exact copy except import UserService from core
import { Component, OnInit }      from '@angular/core';
import { Router } from '@angular/router';
import { PracticesService } from '../../../services/practices.service';
import  {TabsComponent} from '../../../tabs/tabs.component'
import { TabsService } from '../../../services/tabs.service';
import { PracticeComponent } from './practice.component';
import { Practice, Client, Address, City, CityArea, ContactNumber, Specialty } from './practice'

@Component({
  selector: 'app-practices',
  templateUrl: './practices.component.html',
  styleUrls: [ './practices.component.css' ]
})
export class PracticesComponent implements OnInit {
  practice:  Practice;
  practices: Practice[];

  msg = 'Loading contacts ...';
  userName = '';

  constructor(private practicesService: PracticesService, private router: Router, private tabs_service: TabsService) {
    this.tabs_service.register('practices_components');
  }
  ngOnInit() {
    this.practicesService.getPractices().then(practices => {
      this.practices = practices;
    })
  }

  next() {
    let ix = 1 + this.practices.indexOf(this.practice);
    if (ix >= this.practices.length) { ix = 0; }
    this.practice = this.practices[ix];
  }

  onSubmit() {
    this.displayMessage('Saved ' + this.practice.name);
  }
  displayMessage(msg: string) {
    this.msg = msg;
    setTimeout(() => this.msg = '', 1500);
  }
    gotoLink(): void {
        let link = ['/new_practice'];
        this.router.navigate(link);
    }

}


/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
